import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { pageSearch as page, textSearch as text } from '@/shared/api/search'
import { requirePermission } from '@/shared/auth/guards'

export const financeRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/finance',
  beforeLoad: requirePermission('finance.view'),
})

export const entriesRoute = createRoute({
  getParentRoute: () => financeRoute,
  path: 'entries',
  validateSearch: (search) =>
    z
      .object({
        type: z.enum(['receivable', 'payable', 'transfer']).optional().catch(undefined),
        month: z
          .string()
          .regex(/^\d{4}-\d{2}$/)
          .optional()
          .catch(undefined),
        page,
        account: text,
        status: z.enum(['open', 'upcoming', 'paid', 'overdue', 'archived']).optional().catch(undefined),
        search: text,
        code: text,
        category: text,
        company: text,
      })
      .parse(search),
  component: lazyRouteComponent(() => import('./pages/entries-page'), 'EntriesPage'),
})

export const financeSettingsRoute = createRoute({
  getParentRoute: () => financeRoute,
  path: 'settings',
  validateSearch: (search) =>
    z.object({ tab: z.enum(['accounts', 'categories']).optional().catch(undefined) }).parse(search),
  component: lazyRouteComponent(() => import('./pages/settings-page'), 'FinanceSettingsPage'),
})

export const financeRoutes = financeRoute.addChildren([entriesRoute, financeSettingsRoute])
